import { z } from "zod";

export const evaluationReportCreateSchema = z.object({
  sub_category_results: z.array(
    z.object({
      id: z.number(),
      evaluation_note: z.string(),
    }),
  ),
  sdg_target_results: z.array(
    z.object({
      id: z.number(),
      evaluation_note: z.string(),
    }),
  ),
});

export type EvaluationReportCreate = z.infer<
  typeof evaluationReportCreateSchema
>;
